import * as React from 'react'

import { requestPost, } from '../../../../modules/request'
import { Input, } from '../../../Shared/index'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

// this is the same regex we use for saved user email validation, just adjusted for javascript
const validEmailRegex = /^[\w+\-.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+$/

const InviteAdminModal = ({ onSuccess, closeModal, }) => {
  const { modalRef, } = useModalAccessibility(closeModal)

  const [adminName, setAdminName] = React.useState('')
  const [adminEmail, setAdminEmail] = React.useState('')
  const [note, setNote] = React.useState('')

  function handleChangeAdminName(e) { setAdminName(e.target.value) }
  function handleChangeAdminEmail(e) { setAdminEmail(e.target.value) }
  function handleChangeNote(e) { setNote(e.target.value) }

  function handleClickSendRequest() {
    requestPost(`${window.postbuildEnv.DEFAULT_URL}/admin_access/invite_admin`, {
      admin_name: adminName,
      admin_email: adminEmail,
      note
    }, () => {
      onSuccess('Your invite has been sent')
    })
  }

  let sendInviteButton = <button className="quill-button medium contained green focus-on-light" onClick={handleClickSendRequest} type="button">Send invite</button>

  if (adminEmail.length === 0 || adminName.length === 0 || !(validEmailRegex.test(adminEmail))) {
    sendInviteButton = <button className="quill-button medium contained green focus-on-light disabled" disabled type="button">Send invite</button>
  }

  return (
    <div className="modal-container invite-admin-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="inviteAnAdminModalTitle"
        aria-modal={true}
        className="invite-admin-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h3 id="inviteAnAdminModalTitle">Invite an admin</h3>
        <p>Which admin do you want to send this request to?</p>
        <Input
          className="name bordered medium"
          handleChange={handleChangeAdminName}
          id="admins-name"
          label="Admin’s name"
          value={adminName}
        />
        <Input
          className="email bordered medium"
          handleChange={handleChangeAdminEmail}
          id="admins-email"
          label="Admin’s email"
          value={adminEmail}
        />
        <Input
          className="note bordered medium"
          handleChange={handleChangeNote}
          id="note-to-admin"
          label="Note to admin (optional)"
          value={note}
        />
        <div className="button-section">
          <button className="quill-button medium outlined grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          {sendInviteButton}
        </div>
      </div>
    </div>
  )
}

export default InviteAdminModal
